import type { RollupAggregation } from './define';
export { computeRollupValue } from '@streamlain/database-identity';

/**
 * Metadata about aggregation functions for UI
 */
export const AGGREGATION_META: Record<
  RollupAggregation,
  {
    label: string;
    icon: string;
    applicableTo: ('number' | 'string' | 'date' | 'all')[];
  }
> = {
  show_original: {
    label: 'Show original',
    icon: '',
    applicableTo: ['all'],
  },
  show_unique: {
    label: 'Show unique',
    icon: '',
    applicableTo: ['all'],
  },
  count: {
    label: 'Count all',
    icon: '',
    applicableTo: ['all'],
  },
  count_values: {
    label: 'Count values',
    icon: '',
    applicableTo: ['all'],
  },
  count_unique: {
    label: 'Count unique',
    icon: '',
    applicableTo: ['all'],
  },
  sum: {
    label: 'Sum',
    icon: '',
    applicableTo: ['number'],
  },
  average: {
    label: 'Average',
    icon: '',
    applicableTo: ['number'],
  },
  min: {
    label: 'Min',
    icon: '',
    applicableTo: ['number', 'date'],
  },
  max: {
    label: 'Max',
    icon: '',
    applicableTo: ['number', 'date'],
  },
  percent_empty: {
    label: '% empty',
    icon: '',
    applicableTo: ['all'],
  },
  percent_filled: {
    label: '% filled',
    icon: '',
    applicableTo: ['all'],
  },
  concatenate: {
    label: 'Concatenate',
    icon: '',
    applicableTo: ['string'],
  },
};
